
<div class="main-app">
  <app-header [user] = "user"></app-header>

  <div class = "app-body">
    <router-outlet></router-outlet>
  </div>

  <div class="footer">
    <app-footer></app-footer>
  </div>

</div>